import BaseFeature from '../../foundation/base/base';

class CourseList extends BaseFeature {
	constructor(element) {
		super(element);
		this.initDomCache();

		this.el = element;
		this.courseList = this.el;
		this.body = window.features.dom.body;
		this.addToBasket = this.el.querySelectorAll('[data-js="addToBasket"]');
		this.courseHeaderContent = this.el.querySelectorAll('[data-js="courseHeaderContent"]');
		this.courseCenterContent = this.el.querySelectorAll('[data-js="courseCenterContent"]');
		this.listPriceContainer = this.el.querySelectorAll('[data-js="listPriceContainer"]');
		this.listContentContainer = this.el.querySelector('[data-js="listContentContainer"]');
		this.addClick();
	}

	addClick() {
		function syncHeightCourse() {
			const nodeBodyList = document.getElementsByClassName('o-course-list__facts');
			const elemsAssingBody = [].slice.call(nodeBodyList);

			const tallestBody = Math.max(...elemsAssingBody.map((elemBody) => {
				elemBody.style.minHeight = '0'; // eslint-disable-line no-param-reassign
				return elemBody.offsetHeight;
			}));

			elemsAssingBody.forEach((elemBody) => {
				elemBody.style.minHeight = tallestBody + 'px'; // eslint-disable-line no-param-reassign
			});

			const nodeHeaderList = document.getElementsByClassName('a-heading o-course-list__header');
			const elemsHeading = [].slice.call(nodeHeaderList);

			const tallestHeading = Math.max(...elemsHeading.map((elemHeading) => {
				elemHeading.style.minHeight = ''; // eslint-disable-line no-param-reassign
				return elemHeading.offsetHeight;
			}));

			elemsHeading.forEach((elemHeading) => {
				elemHeading.style.minHeight = tallestHeading + 'px'; // eslint-disable-line no-param-reassign
			});
		}
		if (this.el) {
			// Wait for all the images to load calculate
			setTimeout(() => {
				syncHeightCourse();
			}, 100);
			window.addEventListener('resize', syncHeightCourse);
		}

		const mq = window.matchMedia('(max-width: 767px)');
		if (this.listPriceContainer && mq.matches) {
			this.listPriceContainer.forEach((el) => {
				const listPrice = el;
				this.el.querySelector('[data-js="listContentContainer"]').append(listPrice);
			});
		}

		if (this.addToBasket) {
			this.addToBasket.forEach((elem) => {
				elem.addEventListener('click', () => {
					elem.parentNode.parentNode.classList.add('is-loading');
				});
			});
		}
	}
}

export default CourseList;
